import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Award, Plus, Trash2 } from "lucide-react";
import { Card, SecTitle } from "./parts";

export function CertificationsTab({ p, editing, setItem, addItem, delItem }) {
  return (
    <div className="space-y-3">
      <SecTitle icon={Award} conf={p.confidence?.certifications} right={editing && <Button size="sm" variant="outline" onClick={() => addItem("certifications", { name: "", issuer: "", level: "", date: "", credential_id: "" })} data-testid="add-cert"><Plus className="h-3.5 w-3.5 mr-1" />Add</Button>}>Certifications</SecTitle>
      {(p.certifications || []).map((c, i) => (
        <Card key={i} data-testid={`cert-${i}`}>
          {editing ? (
            <div className="grid sm:grid-cols-2 gap-2">
              <Input value={c.name || ""} onChange={(e) => setItem("certifications", i, { name: e.target.value })} placeholder="Certification" className="h-8" />
              <div className="flex gap-2"><Input value={c.issuer || ""} onChange={(e) => setItem("certifications", i, { issuer: e.target.value })} placeholder="Issuer" className="h-8" /><button onClick={() => delItem("certifications", i)} className="text-muted-foreground hover:text-rose-400"><Trash2 className="h-4 w-4" /></button></div>
              <Input value={c.level || ""} onChange={(e) => setItem("certifications", i, { level: e.target.value })} placeholder="Level" className="h-8" />
              <Input value={c.date || ""} onChange={(e) => setItem("certifications", i, { date: e.target.value })} placeholder="Date" className="h-8" />
            </div>
          ) : (
            <div className="flex items-center justify-between gap-3"><div><div className="font-medium text-sm">{c.name}</div><div className="text-xs text-muted-foreground">{[c.issuer, c.level, c.date].filter(Boolean).join(" · ")}{c.credential_id ? ` · ID ${c.credential_id}` : ""}</div></div><Award className="h-5 w-5 text-primary/70" /></div>
          )}
        </Card>
      ))}
      {(p.certifications || []).length === 0 && <p className="text-sm text-muted-foreground">No certifications captured.</p>}
    </div>
  );
}
